var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 185,
    viewBox: "0 0 186 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93 0C41.632 0 0 41.4082 0 92.5C0 143.592 41.632 185 93 185C144.368 185 186 143.592 186 92.5C186 41.4082 144.368 0 93 0ZM66.9891 131.198H48.8613V73.4941H66.9891V131.198ZM57.4348 66.2676H57.2895C50.7141 66.2676 46.4637 61.8594 46.4637 56.2588C46.4637 50.5498 50.8594 46.25 57.5437 46.25C64.2281 46.25 68.3332 50.5498 68.4785 56.2588C68.5148 61.8232 64.2645 66.2676 57.4348 66.2676ZM139.5 131.198H118.938V101.353C118.938 93.5479 115.741 88.2002 108.657 88.2002C103.245 88.2002 100.229 91.8135 98.8488 95.2822C98.3402 96.5107 98.4129 98.2451 98.4129 100.016V131.198H78.0328C78.0328 131.198 78.2871 78.2998 78.0328 73.4941H98.4129V82.5635C99.6117 78.5889 106.114 72.9521 116.504 72.9521C129.401 72.9521 139.5 81.2627 139.5 99.1123V131.198Z",
    fill: "#009688"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.68dbb3549a3ec91923b8e23f59c853ad.svg";
export { ForwardRef as ReactComponent };